<template>
  <v-main>
    <AppBar />
    <AppSideBar v-if="isAdmin" />
    <AppProducerSideBar v-if="isStoreKeeper" />
    <AppAffiliateSideBar v-if="isAffiliate" />
    <v-container fluid>
      <router-view />
    </v-container>
    <StoreSelector />
  </v-main>
</template>

<script>
import { mapGetters } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import AppBar from "@/layouts/components/AppBar.vue";
import AppSideBar from "@/layouts/components/AppSideBar.vue";
import AppProducerSideBar from "@/layouts/components/AppProducerSideBar.vue";
import AppAffiliateSideBar from "@/layouts/components/AppAffiliateSideBar.vue";
import StoreSelector from "@/components/global/StoreSelector.vue";

export default {
  name: "AdminEleven",
  mixins: [displayHelpers],
  components: {
    AppBar,
    AppSideBar,
    AppProducerSideBar,
    StoreSelector,
    AppAffiliateSideBar,
  },
  computed: {
    ...mapGetters(["isAdmin", "isStoreKeeper", "isAffiliate"]),
  },
  beforeMount() {
    if (!this.$axios.getLocal("oe_user_info")) {
      this.$axios.rota("/");
    }
  },
};
</script>

<style scoped></style>
